import { type ActionCreator, on, type ReducerTypes } from '@ngrx/store';
import { produce } from 'immer';

import { type EngineStateBase } from '@blaze-runtime/engine-data-access';

import {
  addOrUpdateConnectionMutably,
  updateWorkflowMutably,
} from '../runtime/runtime.reducer.utils';

import {
  containerActionsRegenerationCompleted,
  containerActionsRegenerationRequest,
  containerActionsRegenerationUpdateWorkflows,
} from './generation.actions';
import { regenerateFormActionsMutably } from './helpers/form-actions.reducer.utils';

export const generationReducerTypes: ReducerTypes<EngineStateBase, ActionCreator[]>[] = [
  on(
    containerActionsRegenerationRequest,
    (state, { buttonDefinition, containerId, styleSheets, actionsLayoutChanged }) =>
      produce(state, (draft) => {
        regenerateFormActionsMutably(
          draft,
          buttonDefinition,
          containerId,
          styleSheets,
          actionsLayoutChanged,
        );
      }),
  ),

  on(containerActionsRegenerationUpdateWorkflows, (state, { refsConnections }) =>
    produce(state, (draft) => {
      for (const c of refsConnections) {
        addOrUpdateConnectionMutably(draft, c);
      }
    }),
  ),

  on(containerActionsRegenerationCompleted, (state, { workflow }) =>
    produce(state, (draft) => {
      updateWorkflowMutably(draft, workflow);
    }),
  ),
];
